const radioBackboneList = [{ id: 1, name: 'new-jersey' },
  { id: 2, name: 'chicago' },
  { id: 3, name: 'toronto' }
];
export default radioBackboneList;
